
    const data = {"name":"src/core/icons/chevron-down copy","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M7.41 8.58 12 13.17l4.59-4.59L18 10l-6 6-6-6 1.41-1.42Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            